import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';

export default function CardHeader({
  title = '',
  description = '',
  tooltipText = '',
  className = '',
  children = null
}) {
  return (
    <UiKit.Flex
      justify="space-between"
      gap={24}
      className={cn(styles.header, className)}
    >
      <UiKit.Flex gap={4} direction="column">
        <UiKit.Title size="md" weight="normal" tooltipText={tooltipText}>
          {title}
        </UiKit.Title>
        <UiKit.Text>{description}</UiKit.Text>
      </UiKit.Flex>
      {children}
    </UiKit.Flex>
  );
}
